import React from 'react';

const StepFiveExtra = ({ data, onChange, errors }) => {
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      onChange({ [name]: checked });
    } else {
      onChange({ [name]: value });
    }
    
    // Clear error when user starts typing
    if (errors[name]) {
      errors[name] = '';
    }
  };

  return (
    <div className="space-y-6">
      {/* Message / Requirements */}
      <div>
        <label htmlFor="messageRequirements" className="block text-sm font-medium mb-2" style={{color: '#3E3E3E'}}>
          Message / Requirements
        </label>
        <textarea
          id="messageRequirements"
          name="messageRequirements"
          value={data.messageRequirements}
          onChange={handleInputChange}
          rows={4}
          className="w-full px-4 py-3 border border-stone-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-colors resize-none"
          placeholder="Tell us about your specific requirements, ideas, or any questions you have about the project..."
          style={{focusRingColor: '#C8A96A'}}
        />
        <p className="mt-1 text-sm text-stone-500">
          Share any specific requirements or ideas for your project
        </p>
      </div>

      {/* WhatsApp Contact */}
      <div className="p-4 rounded-lg border border-stone-200">
        <label className="flex items-center gap-3 cursor-pointer">
          <input
            type="checkbox"
            id="contactWhatsApp"
            name="contactWhatsApp"
            checked={data.contactWhatsApp}
            onChange={handleInputChange}
            className="w-4 h-4 text-primary border-stone-300 rounded focus:ring-primary"
            style={{accentColor: '#C8A96A'}}
          />
          <div className="flex items-center gap-2">
            <span className="material-symbols-outlined text-green-600">whatsapp</span>
            <div>
              <span className="font-medium" style={{color: '#3E3E3E'}}>
                Contact me on WhatsApp
              </span>
              <p className="text-sm text-stone-600">
                Get quick updates and project details on WhatsApp
              </p>
            </div>
          </div>
        </label>
      </div>

      {/* Site Visit Required */}
      <div>
        <label className="block text-sm font-medium mb-3" style={{color: '#3E3E3E'}}>
          Site Visit Required *
        </label>
        <div className="space-y-3">
          <label className="flex items-center gap-3 cursor-pointer p-3 rounded-lg border border-stone-200 hover:border-primary transition-colors">
            <input
              type="radio"
              id="siteVisitYes"
              name="siteVisitRequired"
              value="yes"
              checked={data.siteVisitRequired === 'yes'}
              onChange={handleInputChange}
              className="w-4 h-4 text-primary border-stone-300 focus:ring-primary"
              style={{accentColor: '#C8A96A'}}
            />
            <div>
              <span className="font-medium" style={{color: '#3E3E3E'}}>Yes</span>
              <p className="text-sm text-stone-600">I would like a site visit before consultation</p>
            </div>
          </label>
          
          <label className="flex items-center gap-3 cursor-pointer p-3 rounded-lg border border-stone-200 hover:border-primary transition-colors">
            <input
              type="radio"
              id="siteVisitNo"
              name="siteVisitRequired"
              value="no"
              checked={data.siteVisitRequired === 'no'}
              onChange={handleInputChange}
              className="w-4 h-4 text-primary border-stone-300 focus:ring-primary"
              style={{accentColor: '#C8A96A'}}
            />
            <div>
              <span className="font-medium" style={{color: '#3E3E3E'}}>No</span>
              <p className="text-sm text-stone-600">Online consultation is sufficient</p>
            </div>
          </label>
        </div>
        {errors.siteVisitRequired && (
          <p className="mt-1 text-sm text-red-500">{errors.siteVisitRequired}</p>
        )}
      </div>

      {/* Additional Services */}
      <div>
        <h3 className="text-lg font-medium mb-3" style={{color: '#3E3E3E'}}>Additional Services</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div className="p-3 rounded-lg border border-stone-200">
            <div className="flex items-center gap-2">
              <span className="material-symbols-outlined text-lg" style={{color: '#C8A96A'}}>
                3d_rendering
              </span>
              <div>
                <h4 className="font-medium text-sm" style={{color: '#3E3E3E'}}>3D Rendering</h4>
                <p className="text-xs text-stone-600">Visualize your space</p>
              </div>
            </div>
          </div>
          
          <div className="p-3 rounded-lg border border-stone-200">
            <div className="flex items-center gap-2">
              <span className="material-symbols-outlined text-lg" style={{color: '#C8A96A'}}>
                inventory_2
              </span>
              <div>
                <h4 className="font-medium text-sm" style={{color: '#3E3E3E'}}>Material Selection</h4>
                <p className="text-xs text-stone-600">Choose materials</p>
              </div>
            </div>
          </div>
          
          <div className="p-3 rounded-lg border border-stone-200">
            <div className="flex items-center gap-2">
              <span className="material-symbols-outlined text-lg" style={{color: '#C8A96A'}}>
                attach_money
              </span>
              <div>
                <h4 className="font-medium text-sm" style={{color: '#3E3E3E'}}>Budget Planning</h4>
                <p className="text-xs text-stone-600">Cost optimization</p>
              </div>
            </div>
          </div>
          
          <div className="p-3 rounded-lg border border-stone-200">
            <div className="flex items-center gap-2">
              <span className="material-symbols-outlined text-lg" style={{color: '#C8A96A'}}>
                engineering
              </span>
              <div>
                <h4 className="font-medium text-sm" style={{color: '#3E3E3E'}}>Technical Support</h4>
                <p className="text-xs text-stone-600">Expert guidance</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Terms and Conditions */}
      <div className="p-4 rounded-lg bg-stone-50">
        <div className="flex items-start gap-3">
          <span className="material-symbols-outlined text-lg mt-1" style={{color: '#C8A96A'}}>
            info
          </span>
          <div>
            <h4 className="font-medium mb-2" style={{color: '#3E3E3E'}}>Next Steps</h4>
            <ul className="text-sm text-stone-600 space-y-1">
              <li>• Our team will review your requirements</li>
              <li>• You'll receive a confirmation call within 24 hours</li>
              <li>• Detailed project proposal will be shared</li>
              <li>• Site visit will be scheduled if required</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepFiveExtra;
